import { render, staticRenderFns } from "./InsureRepairItem.vue?vue&type=template&id=4495d1e2&"
import script from "./InsureRepairItem.vue?vue&type=script&lang=js&"
export * from "./InsureRepairItem.vue?vue&type=script&lang=js&"
import style0 from "./InsureRepairItem.vue?vue&type=style&index=0&id=4495d1e2&prod&lang=css&"
import style1 from "./InsureRepairItem.vue?vue&type=style&index=1&id=4495d1e2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports